import Vue from 'vue'
import Axios from 'axios'
import Qs from 'qs'
import { Message, Loading } from 'element-ui'
import store from '@/utils/store.js'
import  router  from '@/router'
import { baseURL } from './index'

const  token_type =store.state.token_type
const  access_token = store.state.token

//强制登录
const must ={
  mustlogin(login){
    const  token_type =store.state.token_type
    const  access_token = store.state.token
    if(login && (token_type==null || access_token==null)){
        router.push({path:'/login'})
        return true
    }
    return false
  }
}
/**
 * 提示函数
 */
const tip = (msg, type) => {
    Message.closeAll();
    Message({
        type: type || 'info',
        message: msg,
        duration: '2000',
        showClose: true
    });
}

/**
 * 跳转登录页
 * 携带当前页面路由，以期在登录页面完成登录后返回当前页面
 */
const toLogin = () => {
    router.push({
        path: '/login',
        /* query: {
            redirect: router.currentRoute.fullPath
        } */
    });
}
const showNoAuth = () => {
    router.push({
        path: '/showNoAuth',
    });
}

/**
 * 错误判断
 */
const errorHandle = (code, msg) => {
    switch (code) {
        case 0:
            console.log(code + ': ' + msg);
            break;
        case 1001:
            tip('账号停用或审核未通过');
            break;
        case 1002:
            tip('账号错误或密码错误');
            break;
        case 1003:
            tip('未签署授权协议');
            break;
        case 1004:
            tip('签署授权协议失败');
            break;
        case 1005:
            tip('没有授权协议数据');
            break;
        case 1006:
            tip('账号不存在');
            break;
        case 1007:
            tip('登录验证码错误');
            break;
        case 1008:
            tip('验证码超时');
            break;
        case 403:
            tip(msg || '登录已失效, 请重新登录.')
            toLogin();
            break;
        case 401:
            console.log(code + ': ' + msg)
           // showNoAuth();
            break;
        default:
            console.log(code + ': ' + msg)
    }
}

// 请求拦截器
Axios.defaults.timeout = 60 * 1000;
Axios.defaults.headers.get['Content-Type'] = 'application/json';
Axios.defaults.headers.post['Content-Type'] = 'application/json';

let loading = null;
// 不显示加载提示接口
Axios.interceptors.request.use(function (config) {
  config.headers = {
    'Content-Type':'application/json' //配置请求头
  }
  //注意使用token的时候需要引入cookie方法或者用本地localStorage等方法，推荐js-cookie
  // const token = getCookie('名称');//这里取token之前，你肯定需要先拿到token,存一下
   const  token_type =store.state.token_type
   const  access_token = store.state.token
  if(token_type!=null && access_token!=null ){
    console.log("认证authorization")
     // config.params = {'token':token} //如果要求携带在参数中
     config.headers= {
       'Content-Type':'application/json',
       'authorization': token_type + ' ' + access_token
     }; //如果要求携带在请求头中
   }else {
    config.headers = {
      'Content-Type':'application/json' //配置请求头
    }
  }
    return config;
}, function (error) {
    !!loading && loading.close();
    // tip('请求超时!')
    console.log('Request: 请求超时.')
    return Promise.reject(error);
});

// Add a response interceptor
Axios.interceptors.response.use(function (response) {
    !!loading && loading.close();
    return response;
}, function (error) {
    !!loading && loading.close();
    console.log(error);
    return Promise.reject(error);
});

export const Post = (url, data) => {
   var mlogin=must.mustlogin(true)
   if(mlogin)return false
    return new Promise((resolve, reject) => {
        Axios.post(baseURL + url, data).then((res) => {
            if (res.status == 200) {
                if (res.data.code == 1) {
                    resolve(res.data)
                } else {
                    errorHandle(res.data.code, res.data.msg || res.data.message);
                    reject(res.data)
                }
            } else {
                console.log('ERROR: ', res.status)
            }
        }).catch((error) => {
            errorHandle(error.response.data.code, error.response.data.msg || error.response.data.message);
            reject(error.response.data);
        })
    })
}

export const Get = (url, data) => {
  var mlogin=must.mustlogin(true)
  if(mlogin)return false
    return new Promise((resolve, reject) => {
        Axios.get(baseURL + url+"?"+Qs.stringify(data)).then((res) => {
            if (res.status == 200) {
                if (res.data.code == 1) {
                    resolve(res.data)
                } else {
                    errorHandle(res.data.code, res.data.msg || res.data.message);
                    reject(res.data)
                }
            } else {
                console.log('ERROR: ', res.status)
            }
        }).catch((error) => {
            errorHandle(error.response.data.code, error.response.data.msg || error.response.data.message);
            reject(error.response.data);
        })
    })
}
export const Put = (url, data) => {
  var mlogin=must.mustlogin(true)
  if(mlogin)return false
    return new Promise((resolve, reject) => {
        Axios.put(baseURL + url, data).then((res) => {
            if (res.status == 200) {
                if (res.data.code == 1) {
                    resolve(res.data)
                } else {
                    errorHandle(res.data.code, res.data.msg || res.data.message);
                    reject(res.data)
                }
            } else {
                console.log('ERROR: ', res.status)
            }
        }).catch((error) => {
            errorHandle(error.response.data.code, error.response.data.msg || error.response.data.message);
            reject(error.response.data);
        })
    })
}
export const Delete = (url, data) => {
  var mlogin=must.mustlogin(true)
  if(mlogin)return false
    return new Promise((resolve, reject) => {
        Axios.delete(baseURL + url, data).then((res) => {
            if (res.status == 200) {
                if (res.data.code == 1) {
                    resolve(res.data)
                } else {
                    errorHandle(res.data.code, res.data.msg || res.data.message);
                    reject(res.data)
                }
            } else {
                console.log('ERROR: ', res.status)
            }
        }).catch((error) => {
            errorHandle(error.response.data.code, error.response.data.msg || error.data.message);
            reject(error.response.data);
        })
    })
}



// WEBPACK FOOTER //
// ./src/api/http.js